module.exports = __webpack_public_path__ + "1ca3abbde3cd5115b01d0254d870c295.png";